import { render, staticRenderFns } from "./UserSignIn.vue?vue&type=template&id=0ddf72b0&"
import script from "./UserSignIn.vue?vue&type=script&lang=js&"
export * from "./UserSignIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports